import React from "react";
import { useIntl } from "react-intl";

import "./ConfirmationDialog.scss";
import Button from "components/atoms/Button/Button";
import Dialog from "../Dialog/Dialog";

type ConfirmationDialogProps = {
  open: boolean;
  onClose: any;
  dialogSize?: string;
  title?: string;
  description?: string;
  submitBtnText?: string;
  onSubmit?: any;
  secondaryBtnText?: string;
  onSecondaryBtnClick?: any;
  customActions?: React.ReactNode;
  submitTestId?: string;
};

function ConfirmationDialog(props: ConfirmationDialogProps) {
  const intl = useIntl();
  const {
    open,
    onClose,
    title,
    description,
    dialogSize,
    onSubmit,
    onSecondaryBtnClick,
    customActions,
    submitTestId,
    submitBtnText = intl.formatMessage({
      id: "general.submit",
      defaultMessage: "Submit",
    }),
    secondaryBtnText = intl.formatMessage({
      id: "general.cancel",
      defaultMessage: "Cancel",
    }),
  } = props;

  return (
    <Dialog className="confirmation-dialog" show={open} size={dialogSize} title={title} onHide={onClose}>
      <div className="text-secondary">{description}</div>
      {customActions ? (
        // for custom action button UI pass as composition..
        <>{customActions}</>
      ) : (
        <div className="d-flex justify-content-between mt-4">
          <Button
            className="rounded-pill font-b1"
            variant="outline-primary"
            style={{ padding: "8px 24px" }}
            label={secondaryBtnText}
            onClick={onSecondaryBtnClick}
          />
          <Button
            className="ml-auto rounded-pill font-b1"
            variant="primary"
            style={{ padding: "8px 24px" }}
            label={submitBtnText}
            onClick={onSubmit}
            data-testid={submitTestId}
          />
        </div>
      )}
    </Dialog>
  );
}

export default ConfirmationDialog;

ConfirmationDialog.defaultProps = {
  title: "",
  description: "",
  dialogSize: "md",
  submitBtnText: undefined,
  secondaryBtnText: undefined,
  onSubmit: undefined,
  onSecondaryBtnClick: undefined,
  customActions: undefined,
  submitTestId: undefined,
};
